import {environment} from '../../environments/environment';
import * as moment from "moment";

const BASE_URL = environment.apiURL;

export const API_CONSTANT = {
  'BASE_URL': BASE_URL,
  MEDIA_PATH_URL: BASE_URL + '/fetch/media/',
  request_otp: BASE_URL + '/api/auth/request-otp/',
  validate_otp: BASE_URL + '/api/auth/validate-otp/',
  login: BASE_URL + '/api-token-auth/',
  logout: BASE_URL + '/api/logout/',
  upload_csv: BASE_URL + '/api/tax_imports/',
  get_errors: BASE_URL + '/api/get_errors/',
  export_import_data_report: BASE_URL + '/api/get_errors/export_report/',
  sign_docs: BASE_URL + '/api/sign_doc/',
  digital_signature: BASE_URL + '/api/certificate/',
  tax_data_upload_result: BASE_URL + '/api/tax_data_upload_result/',
  background_jobs: BASE_URL + '/api/background_jobs/',
  summary_csv: BASE_URL + '/api/summary_csv/',
  zip_file: BASE_URL + '/api/zip_file/',
  sales_tax_report: BASE_URL + '/api/sales_tax_report/',
  zip_file_three_megabyte: BASE_URL + '/api/zip_file_three_megabyte/',
  search_files: BASE_URL + '/api/search_files/',
  sign_counter: BASE_URL + '/api/sign_counter/',
  mark_download: BASE_URL + '/api/mark_download/',
  dashboard_monthly: BASE_URL + '/api/dashboard_monthly/',
  dashboard_sms_monthly: BASE_URL + '/api/dashboard_sms_monthly/',
  dashboard_sign_counter_minute: BASE_URL + '/api/dashboard_sign_counter_minute/',
  dashboard_length: BASE_URL + '/api/dashboard_length/',
  dashboard_activity: BASE_URL + '/api/dashboard_activity/',
  set_password: BASE_URL + '/api/set_password/',
  confirm_password: BASE_URL + '/api/confirm_password/',
  users: BASE_URL + '/api/users/',
  groups: BASE_URL + '/api/groups/',
  company_groups: BASE_URL + '/api/companygroups/',
  me: BASE_URL + '/api/me/',
  corporates: BASE_URL + '/api/corporates/',
  group_corporates: BASE_URL + '/api/group-corporates/',
  branches: BASE_URL + '/api/corporate-branches/',
  document_type: BASE_URL + '/api/documents_type/',
  sales_tax_view: BASE_URL + '/api/sales_tax_views/',
  bulk_sales_tax_view: BASE_URL + '/api/bulk_sales_tax_views/',
  export_missing_excel: BASE_URL + '/api/export_excel_missing_docs/',
  export_bulk_missing_excel: BASE_URL + '/api/export_bulk_excel_missing_docs/',
  approve_sale_tax: BASE_URL + '/api/approved_sales_tax/',
  export_all_docs: BASE_URL + '/api/export_excel_all_docs/',
  export_bulk_all_docs: BASE_URL + '/api/export_bulk_excel_all_docs/',
  export_monthly_excel_report: BASE_URL + '/api/export_excel_monthly_report/',
  submit_checked_to_rd: BASE_URL + '/api/submit_checked_to_rd/',
  sales_zip_tax: BASE_URL + '/api/sales_tax_zip_views/',
  submit_to_rd: BASE_URL + '/api/submit_to_rd_views/',
  resend_all_pending_ebxml: BASE_URL + '/api/resend_all_pending_ebxml/',
  get_latest_manual_resend_time: BASE_URL + '/api/get_latest_manual_resend_time/',
  approve_upload_sale: BASE_URL + '/api/approved_uploaded_sales_tax_zip/',
  update_settings: BASE_URL + '/api/update_settings/',
  get_settings: BASE_URL + '/api/get_settings/',
  export_zip_file: BASE_URL + '/api/zip_file_three_megabyte/',
  export_excel_submit_to_rd: BASE_URL + '/api/export_excel_submit_to_rd/',
  buyer: BASE_URL + '/api/buyer/',
  b2p_document_summary: BASE_URL + '/api/b2p_document_summary/',
  b2p_document_summary_detail: BASE_URL + '/api/b2p_document_summary_detail/',
  b2p_document_summary_detail_excel: BASE_URL + '/api/b2p_document_summary_detail_excel/',
  export_billing_monthly_excel_report: BASE_URL + '/api/export_sign_counter_excel_monthly_report/',
  export_actions_log_excel_report: BASE_URL + '/api/export_actions_log_excel_report/',
  email_report: BASE_URL + '/api/email_report/',
  cancel_no_ref: BASE_URL + '/api/cancel_no_ref/',
  rd_send_results: BASE_URL + '/api/rd_send_results/',
  log_actions: BASE_URL + '/api/log_actions/',
  history_log: BASE_URL + '/api/logs/',
  history_log_type: BASE_URL + '/api/history_log_type/',
  roles: BASE_URL + '/api/roles/',
  usernames: BASE_URL + '/api/usernames/',
  errors: BASE_URL + '/api/errors/',
  country: BASE_URL + '/api/countries/',
  all_buyer_emails_report: BASE_URL + '/api/all_buyer_emails_report/',
  all_buyer_name_email_report: BASE_URL + '/api/all_buyer_name_email_report/',
  buyer_branch: BASE_URL + '/api/buyer_branch/',
  invoice_no: BASE_URL + '/api/invoice_no/',
  create_etax_invoice: BASE_URL + '/api/create_etax_invoice/',
  send_email_document_issue: BASE_URL + '/api/send_email_document_issue/',
  matched_invoice_number: BASE_URL + '/api/matched_invoice_number/',
  send_email_etax_invoice: BASE_URL + '/api/send_email_etax_invoice/',
  resend_via_email_dashboard: BASE_URL + '/api/resend_via_email_dashboard/',
  export_csv_template: BASE_URL + '/api/export_csv_template/'
};



// WEBPACK FOOTER //
// /opt/app/src/app/services/api.constant.ts